import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ConfirmHost } from "./components/ConfirmDialog";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop";
import PageTracker from "./components/PageTracker";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { GeoNotice } from "./components/GeoNotice";
import { ChatWidget } from "./components/ChatWidget";
import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import ExtensionRules from "./pages/ExtensionRules";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import BookingSuccess from "./pages/BookingSuccess";
import Portal from "./pages/Portal";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import Complaints from "./pages/Complaints";
import SiteVisitManage from "./pages/SiteVisitManage";

function SiteChat() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;
  // Inside the quote wizard on phones the floating launcher sits over the form's
  // tap targets (time slots, submit) — the wizard has its own "ask us to call" card.
  return <ChatWidget hideLauncherOnMobile={loc.pathname.startsWith("/quote")} />;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop/>
      <PageTracker/>
      <div className="App min-h-screen flex flex-col">
        <Header/>
        <GeoNotice/>
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/how-it-works" element={<HowItWorks/>}/>
            <Route path="/extension-rules" element={<ExtensionRules/>}/>
            <Route path="/about" element={<About/>}/>
            <Route path="/faq" element={<FAQ/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="/quote" element={<Quote/>}/>
            <Route path="/gallery" element={<Gallery/>}/>
            <Route path="/blog" element={<Blog/>}/>
            <Route path="/blog/:id" element={<BlogArticle/>}/>
            <Route path="/booking/success" element={<BookingSuccess/>}/>
            <Route path="/booking/cancel" element={<BookingSuccess/>}/>
            <Route path="/portal" element={<Portal/>}/>
            <Route path="/admin" element={<Admin/>}/>
            <Route path="/legal/:doc" element={<Legal/>}/>
            <Route path="/complaints" element={<Complaints/>}/>
            <Route path="/site-visit/:token" element={<SiteVisitManage/>}/>
          </Routes>
        </div>
        <Footer/>
        <SiteChat/>
        <Toaster position="top-right" richColors/>
        <ConfirmHost/>
      </div>
    </BrowserRouter>
  );
}
export default App;
